/**
 * Typed node data interfaces -- AUTO-GENERATED from schemas/nodes/*.json.
 *
 * Do not edit manually. Run: python scripts/gen_node_metas.py
 */

import * as Y from 'yjs'

// ---------------------------------------------------------------------------
// Shared types (auto-generated from schemas/shared_types.json)
// ---------------------------------------------------------------------------

export type BasicAsset = { id: string; local_path?: string; r2_url?: string; metadata?: Record<string, string | number | boolean | null> }

export type AssetRef = { type: string; data: BasicAsset }

export type GeneratedAssetEntry = { user_prompt?: string; result?: BasicAsset; refs?: AssetRef[]; metadata?: Record<string, string | number | boolean | null> }

export type GeneratedImageWithHistoryData = { history: GeneratedAssetEntry[]; picked_index: number }

export type GeneratedVideoWithHistoryData = { history: GeneratedAssetEntry[]; picked_index: number }

export type GeneratedAudioWithHistoryData = { history: GeneratedAssetEntry[]; picked_index: number }

// ---------------------------------------------------------------------------
// Named port types (auto-generated from schema pythonType → tsType)
// ---------------------------------------------------------------------------

export type AppearanceDict = Array<{ character_id: string; expression?: string; pose?: string; position?: string }>

export type AudioRemixConfigDict = { groups: Array<{ id: string; character: string; emotion?: string; text?: string; status?: string; type?: 'dialogue' | 'voiceover'; tracks: Array<{ id: string; label: string; startS: number; endS: number; highlighted: boolean; sourceSegmentIdx?: number; sourceVersionLabel?: string; fadeInS?: number; fadeOutS?: number; sourceDurationS?: number }> }> }

export type BubbleDict = Array<{ panel: number; type: string; text: string; speaker?: string; x: number; y: number; width: number; height: number }>

export type CharacterAsset = { user_prompt?: string; images?: { main?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } }; character_sheet?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } }

export type CompositionDict = { shot_type?: string; angle?: string; focus?: string }

export type DialogueEntryDict = Array<{ clip_index: number; voice_text: string; voice_character: string; start_s: number; end_s: number; type?: string }>

export type GeneratedAudioWithHistory = GeneratedAudioWithHistoryData

export type GeneratedImageWithHistory = GeneratedImageWithHistoryData

export type GeneratedVideoWithHistory = GeneratedVideoWithHistoryData

export type LocationAsset = { user_prompt?: string; images?: { main?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } } }

export type MetadataDict = Record<string, string | number | boolean | null>

export type ObjectAsset = { user_prompt?: string; images?: { main?: { history?: Array<{ result?: { local_path?: string } }>; picked_index?: number } } }

export type PanelDescriptionDict = Array<{ panel_id: string; description: string; characters?: string[]; location?: string }>

export type PanelDialogueDict = Array<{ speaker: string; text: string; type?: string }>

export type ReconciledDialogueEntryDict = Array<{ character: string; intended_text: string; actual_text: string; replacement_text: string; start_s: number; end_s: number; duration_s: number; emotion: string; intensity: number; status: string }>

export type ReviewHistoryEntryDict = Array<{ feedback: string; round: number; accepted?: boolean; attempt?: number }>

export type SceneTextDict = Array<{ scene_number: number; text: string }>

export type ScreenplayResultDict = { error?: string; scenes?: Array<{ scene_number: number; location: string; interior_exterior?: string; time_of_day?: string; characters?: string[]; entries: Array<{ type: string; character?: string; emotion?: string; text: string }> }> }

export type ScriptDialogueDict = Array<{ character: string; text: string; emotion?: string; scene_number?: number; type?: string }>

export type ScriptScreenplaySceneDict = Array<{ scene_number: number; location: string; interior_exterior: string; characters: string[]; entries: Array<Record<string, string>> }>

export type SoundGeneratedAudioDict = { history?: Array<{ user_prompt?: string; result?: { local_path?: string; metadata?: Record<string, string | number | boolean | null> }; metadata?: Record<string, string | number | boolean | null> }>; picked_index?: number }

export type SpeechSegmentDict = Array<{ character: string; emotion: string; timeRange: string; audioUrl: string | null; versions: number; selectedVersion: number }>

export type SpeechWindowDict = Array<{ start_s: number; end_s: number; confidence: number }>

export type StoryContextDict = { synopsis?: string; characters?: string[]; setting?: string }

export type StoryDirectionFieldDict = { value: string; status: string }

export type TransitionDict = Array<{ type: string; description: string; from_panel?: string; to_panel?: string }>

export type TtsSegmentDict = Array<{ index: number; character: string; text: string; audio_path: string; duration_s: number; start_s: number; end_s: number; path?: string; original_path?: string; tts_end_s?: number; emotion?: string; status?: string; versions?: Array<{ label: string; path: string }> }>

export type VoiceProfileDict = { voice_id: string; voice_name: string; description: string; name?: string; audio_sample?: string; speech_text?: string; characteristics?: string[] }

export type VoiceSettingsDict = { stability?: number; similarity_boost?: number; style?: number; speed?: number }

export type WebtoonDialogueDict = Array<{ character: string; text: string }>

export type dict = Record<string, unknown>

export type NodeStatus = 'pending_execution' | 'running' | 'completed' | 'error' | 'idle' | 'pending_cost_confirmation'

export const NODE_STATUSES = ['pending_execution', 'running', 'completed', 'error', 'idle', 'pending_cost_confirmation'] as const

/** Design a character with visual sheet and voice profile */
export interface CharacterDesignerNodeData {
  /** Context from upstream director or workflow node */
  in_upstream?: MetadataDict
  /** Optional reference image to guide the visual design */
  in_reference_images?: string[]
  /** Name of the character being designed */
  in_name?: string
  /** Character role (e.g. protagonist, supporting, antagonist) */
  in_role?: string
  /** Visual art style for the character sheet */
  in_style?: string
  /** Describe appearance, personality, voice... */
  in_description?: string
  /** Regeneration feedback from user or agent */
  in_feedback?: string
  /** Character name (mirrors in_name for downstream label edges) */
  out_name?: string
  /** Generated multi-view character reference sheet */
  out_character_sheet?: CharacterAsset
  /** Voice metadata including voice_id, voice_name, and description */
  out_voice_profile?: VoiceProfileDict
  /** Currently-picked image's project-relative path */
  out_image_path?: string
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Debug node that hangs forever for testing */
export interface DebugHangNodeData {
  /** Debug label */
  in_label?: string
  /** Debug result */
  out_result?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Post-storyboard agent that generates dialogue for transitions between panels */
export interface DialogueWriterNodeData {
  /** Storyboard panel image paths for dialogue generation */
  in_storyboard?: string[]
  /** Story context and synopsis */
  in_story_context?: string
  /** Character reference sheets */
  in_characters?: string[]
  /** Generated dialogue entries */
  out_dialogue?: DialogueEntryDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Orchestrate workflow and chat with the AI director */
export interface DirectorNodeData {
  /** Optional context for the conversation */
  in_context?: string
  /** Director response text */
  out_response?: string
  /** Crew configuration for sub-agents */
  out_crew?: MetadataDict
  /** pending_tool_state */
  pending_tool_state?: MetadataDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate images from text prompts using Gemini */
export interface ImageGeneratorNodeData {
  /** Optional reference image to guide the generation */
  in_reference_images?: string[]
  /** Context from upstream director or workflow node */
  in_upstream?: MetadataDict
  /** Optional label for the generator node */
  in_name?: string
  /** Text description of the image to generate */
  in_prompt?: string
  /** Aspect ratio for the generated image */
  in_aspect_ratio?: string
  /** Visual art style for the generated image */
  in_style?: string
  /** Output resolution quality */
  in_quality?: string
  /** Designer node IDs for self-wiring reference edges */
  in_panel_refs?: string[]
  /** When True, store in_image directly (passthrough mode) */
  in_update?: boolean
  /** Incoming panel image from storyboard */
  in_image?: string
  /** Regeneration feedback from user or agent */
  in_feedback?: string
  /** Video file path (RelativePath) from upstream video generator */
  in_video?: string
  /** Which frame to extract: first, last, or integer string (0-indexed) */
  in_frame?: string
  /** When true, skip image generation and extract frame from in_video */
  in_get_frame?: boolean
  /** The generated image */
  out_generated_image?: GeneratedImageWithHistory
  /** Currently-picked image's project-relative path */
  out_image_path?: string
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Design a location/background with reference image */
export interface LocationDesignerNodeData {
  /** Optional reference image to guide the visual design */
  in_reference_images?: string[]
  /** Name of the location being designed */
  in_name?: string
  /** Visual art style for the location */
  in_style?: string
  /** Time of day for the scene */
  in_time_of_day?: string
  /** Weather condition for the scene */
  in_weather?: string
  /** Describe the location, atmosphere, key elements... */
  in_description?: string
  /** Regeneration feedback from user or agent */
  in_feedback?: string
  /** Location name (mirrors in_name for downstream label edges) */
  out_name?: string
  /** Generated location reference image */
  out_location_image?: LocationAsset
  /** Location metadata including name, style, time, and weather */
  out_metadata?: MetadataDict
  /** Currently-picked image's project-relative path */
  out_image_path?: string
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate background music from a text prompt */
export interface MusicGeneratorNodeData {
  /** Text description of the desired music */
  in_prompt?: string
  /** Optional duration hint (e.g. 30s, 1 minute) */
  in_length?: string
  /** Generated music audio file */
  out_audio_file?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Visual group container for organizing nodes */
export interface NodeGroupNodeData {
  /** Display label for the group */
  in_label?: string
  /** IDs of child nodes contained in this group. Null entries represent empty gap slots left by drag-out; use Rearrange to compact. */
  in_child_node_ids?: string[]
  /** Child arrangement mode: horizontal (single row), vertical (single column), or auto (grid) */
  in_layout_mode?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Design an object/artifact with reference image */
export interface ObjectDesignerNodeData {
  /** Optional reference image to guide the visual design */
  in_reference_images?: string[]
  /** Name of the object being designed */
  in_name?: string
  /** Visual art style for the object */
  in_style?: string
  /** Describe the object appearance, material, details... */
  in_description?: string
  /** Regeneration feedback from user or agent */
  in_feedback?: string
  /** Object name (mirrors in_name for downstream label edges) */
  out_name?: string
  /** Generated object reference image */
  out_object_image?: ObjectAsset
  /** Object metadata */
  out_metadata?: MetadataDict
  /** Currently-picked image's project-relative path */
  out_image_path?: string
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** All-in-one agent that generates panels, transitions, dialogue, and music moods from story context */
export interface ScreenplayWriterNodeData {
  /** Story context and synopsis for screenplay generation */
  in_story_context?: StoryContextDict
  /** Character reference sheets */
  in_characters?: string[]
  /** Location reference images */
  in_locations?: string[]
  /** Optional user-provided script or outline */
  in_user_script?: string
  /** Visual art style */
  in_style?: string
  /** 9 panel descriptions */
  out_panels?: PanelDescriptionDict
  /** 8 transition specs between panels */
  out_transitions?: TransitionDict
  /** 8 dialogue entries with voice text and character */
  out_dialogue?: ScriptDialogueDict
  /** 8 music prompt strings */
  out_music_prompts?: string[]
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Interactive conversational story writer */
export interface ScriptWriterNodeData {
  /** Story prompt or instructions */
  in_prompt?: string
  /** Selected model variant: gemini, claude, or gpt */
  in_active_model?: string
  /** Project or scene name */
  in_name?: string
  /** Director's creative guidance composed from user Q&A — tone, structure, pacing, and other creative direction */
  in_director_instruction?: string
  /** When true, the Script Writer only reformats the user prompt into screenplay structure without adding, modifying, or removing storyline content */
  in_format_only?: boolean
  /** Character names */
  in_characters?: string[]
  /** Revision instructions from Director's revise_screenplay tool */
  in_feedback?: string
  /** Optional target total duration in seconds; used to compute suggested scene count */
  in_target_duration_s?: number
  /** Generated script content */
  out_script?: string
  /** Path to saved script file */
  out_script_path?: string
  /** Structured screenplay (array of scene objects with typed entries) */
  out_screenplay?: ScriptScreenplaySceneDict
  /** Extracted dialogue entries with character, emotion, and text */
  out_dialogue?: ScriptDialogueDict
  /** Extracted action/staging direction entries per scene */
  out_action_lines?: SceneTextDict
  /** Deduplicated list of character names appearing in the screenplay */
  out_characters?: string[]
  /** Music mood/genre cue entries per scene */
  out_music_cues?: SceneTextDict
  /** Sound effect entries per scene */
  out_sfx?: SceneTextDict
  /** Raw ScreenplayResult JSON from Gemini */
  out_gemini?: ScreenplayResultDict
  /** Raw ScreenplayResult JSON from Claude Opus 4 */
  out_claude?: ScreenplayResultDict
  /** Raw ScreenplayResult JSON from GPT-4o */
  out_gpt?: ScreenplayResultDict
  /** Extracted location names from screenplay */
  out_locations?: string[]
  /** Which model variant was selected (gemini, claude, or gpt) */
  out_active_model?: string
  /** Number of scenes in the generated screenplay */
  out_scene_count?: number
  /** Script review feedback history */
  in_review_history?: ReviewHistoryEntryDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate music, speech, or sound effects with three unified modes */
export interface SoundExpertNodeData {
  /** Display name for the node (FloatingNodeLabel) */
  in_name?: string
  /** Upstream dependency trigger */
  in_upstream?: MetadataDict
  /** Free-text description of desired audio (music/sfx) */
  in_prompt?: string
  /** Audio generation mode: music, speech, or sfx */
  in_mode?: string
  /** Duration hint as human-readable string (music/sfx only) */
  in_duration?: string
  /** Voice profile { voice_id, voice_name } from CharacterDesigner (speech mode) */
  in_voice_profile?: VoiceProfileDict
  /** Dialogue script with @-mentions and timestamps (speech mode) */
  in_text?: string
  /** Audio generation model identifier */
  in_model?: string
  /** Whether to loop the audio (sfx mode) */
  in_loop?: string
  /** Lyrics generation mode for music (auto/custom/instrumental) */
  in_lyrics_mode?: string
  /** Generated audio file path */
  out_audio?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Generated audio with history and picked index */
  in_generated_audio?: SoundGeneratedAudioDict
  /** batch_pending */
  batch_pending?: number
  /** Legacy: direct path to audio file. TODO: Remove after full canvas-v2 migration */
  audio_file?: string
  /** Per-character speech segments with voice acting results */
  speech_segments?: SpeechSegmentDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate speech audio from text using TTS */
export interface SpeechGeneratorNodeData {
  /** Text to convert to speech */
  in_text?: string
  /** Voice profile from CharacterDesigner (contains voice_id) */
  in_voice_profile?: VoiceProfileDict
  /** Scene identifier for organizing generated audio */
  in_scene_id?: string
  /** Speech generation mode */
  in_mode?: string
  /** Full script text with speaker annotations */
  in_script?: string
  /** ElevenLabs voice ID */
  in_voice_id?: string
  /** Character name for voice mode */
  in_character_name?: string
  /** Character name to voice ID mapping */
  in_voice_map?: Record<string, { voice_id: string; voice_name: string | null }>
  /** Pause between segments in milliseconds */
  in_pause_ms?: number
  /** TTS provider */
  in_provider?: string
  /** For ordering in video_editor */
  in_panel_index?: number
  /** Generated speech audio file */
  out_audio_file?: string
  /** Audio duration in seconds */
  out_duration_seconds?: number
  /** Normalized amplitude peaks for visualization (150 samples) */
  out_waveform?: number[]
  /** DEPRECATED */
  out_generated_audio?: GeneratedAudioWithHistory
  /** Generated audio with history and picked index */
  in_generated_audio?: GeneratedAudioWithHistory
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Story shaping dimensions: premise, tone, hook, structure */
export interface StoryDirectionPreviewNodeData {
  /** premise */
  premise?: StoryDirectionFieldDict
  /** tone */
  tone?: StoryDirectionFieldDict
  /** hook */
  hook?: StoryDirectionFieldDict
  /** structure */
  structure?: StoryDirectionFieldDict
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate a 9-grid storyboard from a script or scene description */
export interface StoryboardDesignerNodeData {
  /** Script or scene breakdown to visualize as storyboard */
  in_script?: string
  /** Character reference sheets for visual consistency */
  in_characters?: string[]
  /** Character names from designer out_name ports */
  in_character_names?: string[]
  /** Location reference images for scene setting */
  in_locations?: string[]
  /** Location names from designer out_name ports */
  in_location_names?: string[]
  /** Object reference images for props and items */
  in_objects?: string[]
  /** Object names from designer out_name ports */
  in_object_names?: string[]
  /** Optional reference images to guide the storyboard generation */
  in_reference_images?: string
  /** Visual art style for the storyboard */
  in_style?: string
  /** Number of panels (default 9 for 9-grid) */
  in_panel_count?: number
  /** Scene identifier for the storyboard */
  in_scene_id?: string
  /** Location for the scene */
  in_location?: string
  /** User feedback for regeneration */
  in_feedback?: string
  /** History of generated 9-panel storyboard grid images (latest is current) */
  out_storyboard_grid?: string[]
  /** Storyboard metadata including beat descriptions */
  out_metadata?: MetadataDict
  /** Beat descriptions per panel */
  out_beats?: string[]
  /** Per-panel list of designer node IDs */
  out_panel_refs?: string[][]
  /** Cropped panel image paths */
  out_panel_images?: string[]
  /** picked_storyboard_index */
  picked_storyboard_index?: number
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate a 9-grid storyboard without per-panel enhancement */
export interface StoryboardNoEnhanceDesignerNodeData {
  /** Script or scene breakdown to visualize */
  in_script?: string
  /** Character reference sheets */
  in_characters?: string[]
  /** Character names from designer out_name ports */
  in_character_names?: string[]
  /** Location reference images */
  in_locations?: string[]
  /** Location names from designer out_name ports */
  in_location_names?: string[]
  /** Visual art style */
  in_style?: string
  /** Number of panels */
  in_panel_count?: number
  /** Scene identifier */
  in_scene_id?: string
  /** Location for the scene */
  in_location?: string
  /** Relative path to 9-grid image */
  out_storyboard_grid?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Edit videos: stitch clips, add audio, or trim duration */
export interface VideoEditorNodeData {
  /** Multiple video clips to stitch together (in order) */
  in_video_paths?: string[]
  /** Audio files to add to video */
  in_audio_paths?: string[]
  /** Single audio file for add_audio operation */
  in_audio_path?: string
  /** Edit operation mode */
  in_mode?: string
  /** Output file name */
  in_output_name?: string
  /** Trim start time */
  in_start?: number
  /** Trim end time */
  in_end?: number
  /** Audio volume */
  in_volume?: number
  /** Timeline render configuration (clips, audio, duration) */
  in_timeline_config?: dict
  /** Edited video output */
  out_video_output?: string
  /** Clip file paths used in last render (for draft detection) */
  out_rendered_clip_paths?: string[]
  /** action */
  action?: string
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate video clips from prompts and reference images, with optional audio remix */
export interface VideoGeneratorNodeData {
  /** Video generation mode */
  in_mode?: string
  /** Scene identifier for organizing clips */
  in_scene_id?: string
  /** Clip number within the scene */
  in_clip_number?: number
  /** Reference/first-frame images for generation */
  in_reference_images?: string[]
  /** Optional audio track to bake into the video */
  in_audio?: string
  /** Describe the video action and motion */
  in_motion_prompt?: string
  /** Broader scene context for coherent generation */
  in_scene_context?: string
  /** Video duration in seconds */
  in_duration?: number
  /** Structured per-line dialogue for voice acting (list of {character, line, emotion} dicts) */
  in_dialogue_prompt?: DialogueEntryDict
  /** Video generation model */
  in_model?: string
  /** Video aspect ratio */
  in_aspect_ratio?: string
  /** Video output resolution */
  in_resolution?: string
  /** Whether to generate audio remix after video generation */
  in_generate_audio?: boolean
  /** TTS backend for audio remix (elevenlabs or gemini) */
  in_tts_provider?: string
  /** Voice profiles from connected character designers */
  in_voice_map?: VoiceProfileDict[]
  /** TTS voice tuning parameters (stability, similarity_boost, style, speed) */
  in_voice_settings?: VoiceSettingsDict
  /** Optional label for the video node */
  in_name?: string
  /** Character name to resolved voice display name mapping (from voice acting) */
  in_resolved_voice_map?: Record<string, string>
  /** Full audio remix editor state: groups of tracks with positions, highlights, and order. Set by user via Audio Remix modal or by Director agent. */
  in_audio_remix_config?: AudioRemixConfigDict
  /** Generated video clip with metadata */
  out_generated_video?: GeneratedVideoWithHistory
  /** Video with replaced dialogue audio */
  out_remixed_video?: string
  /** Mixed audio track (ducked original + replacement TTS) */
  out_replacement_mix?: string
  /** Per-line TTS audio segments with versioned paths, timing, and emotion */
  out_tts_segments?: TtsSegmentDict
  /** Detected speech regions with timestamps and confidence */
  out_speech_windows?: SpeechWindowDict
  /** The timed prompt sent to Veo */
  out_video_prompt?: string
  /** Video duration in seconds */
  out_video_duration?: number
  /** Reconciled dialogue data from voice acting pipeline */
  out_dialogue?: ReconciledDialogueEntryDict
  /** Currently-picked video's project-relative path */
  out_video_path?: string
  /** voice_acting_status */
  voice_acting_status?: string
  /** action */
  action?: string
  /** segment_index */
  segment_index?: number
  /** batch_pending */
  batch_pending?: number
  /** Legacy: video thumbnail path. TODO: Remove after full canvas-v2 migration */
  thumbnail?: string
  /** Whether this node is rendered inside a group node */
  is_inside_group?: boolean
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Collapsible group container for webtoon panels arranged vertically */
export interface WebtoonGroupNodeData {
  /** Scene identifier (e.g., ch1_s2) */
  in_scene_id?: string
  /** Display label (e.g., Chapter 1, Scene 2) */
  in_label?: string
  /** Whether the group is collapsed (internal, managed by UI toggle) */
  in_collapsed?: boolean
  /** IDs of child panel nodes */
  in_child_node_ids?: string[]
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

/** Generate a webtoon page with multiple sub-panels and text bubbles */
export interface WebtoonPanelGeneratorNodeData {
  /** Storyboard panel thumbnails + character/location reference images */
  in_reference_images?: string[]
  /** Combined visual description for the page (fallback if beats not provided) */
  in_prompt?: string
  /** List of beat descriptions for sub-panels on this page */
  in_beats?: string[]
  /** Structured dialogue entries for text bubble overlay */
  in_dialogue?: WebtoonDialogueDict[]
  /** Page position in the scene (0-based) */
  in_panel_index?: number
  /** Page aspect ratio */
  in_aspect_ratio?: string
  /** Panel layout type for page composition */
  in_layout?: string
  /** Visual art style */
  in_style?: string
  /** Page name */
  in_name?: string
  /** User feedback */
  in_feedback?: string
  /** Webtoon page with sub-panels and text bubbles */
  out_panel_image?: GeneratedImageWithHistory
  /** bubbles */
  bubbles?: BubbleDict
  /** batch_pending */
  batch_pending?: number
  // Common status fields
  status?: NodeStatus
  progress?: number
  error?: string
  projectId?: string
  cacheKey?: string
  label?: string
  progressMessage?: string
}

export type AnyNodeData = CharacterDesignerNodeData | DebugHangNodeData | DialogueWriterNodeData | DirectorNodeData | ImageGeneratorNodeData | LocationDesignerNodeData | MusicGeneratorNodeData | NodeGroupNodeData | ObjectDesignerNodeData | ScreenplayWriterNodeData | ScriptWriterNodeData | SoundExpertNodeData | SpeechGeneratorNodeData | StoryDirectionPreviewNodeData | StoryboardDesignerNodeData | StoryboardNoEnhanceDesignerNodeData | VideoEditorNodeData | VideoGeneratorNodeData | WebtoonGroupNodeData | WebtoonPanelGeneratorNodeData

/** Backend type to interface type mapping */
export type NodeDataMap = {
  'character_designer': CharacterDesignerNodeData
  'debug_hang': DebugHangNodeData
  'dialogue_writer': DialogueWriterNodeData
  'director': DirectorNodeData
  'image_generator': ImageGeneratorNodeData
  'location_designer': LocationDesignerNodeData
  'music_generator': MusicGeneratorNodeData
  'node_group': NodeGroupNodeData
  'object_designer': ObjectDesignerNodeData
  'screenplay_writer': ScreenplayWriterNodeData
  'script_writer': ScriptWriterNodeData
  'sound_expert': SoundExpertNodeData
  'speech_generator': SpeechGeneratorNodeData
  'story_direction_preview': StoryDirectionPreviewNodeData
  'storyboard_designer': StoryboardDesignerNodeData
  'storyboard_no_enhance_designer': StoryboardNoEnhanceDesignerNodeData
  'video_editor': VideoEditorNodeData
  'video_generator': VideoGeneratorNodeData
  'webtoon_group': WebtoonGroupNodeData
  'webtoon_panel_generator': WebtoonPanelGeneratorNodeData
}

export type YDocWireType = 'primitive' | 'json' | 'array' | 'map'

export interface YDocFieldDef {
  schemaType: string
  wireType: YDocWireType
  isMulti: boolean
  baseType: string
}

export const YDOC_NODE_FIELDS: Record<string, Record<string, YDocFieldDef>> = {
  audio: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  character_designer: {
    in_upstream: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
    in_reference_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_role: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_character_sheet: { schemaType: 'image', wireType: 'json', isMulti: false, baseType: 'CharacterAsset' },
    out_voice_profile: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'VoiceProfileDict' },
    out_image_path: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  debug_hang: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_result: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  dialogue_writer: {
    in_storyboard: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_story_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    out_dialogue: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'DialogueEntryDict' },
  },
  director: {
    in_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_response: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_crew: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
  },
  generated_image_with_history: {
  },
  image: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  image_generator: {
    in_reference_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_upstream: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'AspectRatio' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_quality: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_refs: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_update: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_video: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_frame: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_get_frame: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    out_generated_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'GeneratedImageWithHistory' },
    out_image_path: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  location_designer: {
    in_reference_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_time_of_day: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_weather: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_location_image: { schemaType: 'image', wireType: 'json', isMulti: false, baseType: 'LocationAsset' },
    out_metadata: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
    out_image_path: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  music_generator: {
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_length: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_audio_file: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  node_group: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    in_layout_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  object_designer: {
    in_reference_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_description: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_object_image: { schemaType: 'image', wireType: 'json', isMulti: false, baseType: 'ObjectAsset' },
    out_metadata: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
    out_image_path: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  panel_source: {
    out_image: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_action: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_characterIds: { schemaType: 'json', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    out_appearances: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'AppearanceDict' },
    out_dialogue: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'PanelDialogueDict' },
    out_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_composition: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'CompositionDict' },
  },
  prompt_input: {
    out_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  screenplay_writer: {
    in_story_context: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'StoryContextDict' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_user_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    out_panels: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'PanelDescriptionDict' },
    out_transitions: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'TransitionDict' },
    out_dialogue: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ScriptDialogueDict' },
    out_music_prompts: { schemaType: 'json', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  script_writer: {
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_active_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_director_instruction: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_format_only: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_characters: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_target_duration_s: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    out_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_script_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_screenplay: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ScriptScreenplaySceneDict' },
    out_dialogue: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ScriptDialogueDict' },
    out_action_lines: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'SceneTextDict' },
    out_characters: { schemaType: 'json', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    out_music_cues: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'SceneTextDict' },
    out_sfx: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'SceneTextDict' },
    out_gemini: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ScreenplayResultDict' },
    out_claude: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ScreenplayResultDict' },
    out_gpt: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ScreenplayResultDict' },
    out_locations: { schemaType: 'json', wireType: 'array', isMulti: false, baseType: 'list[str]' },
    out_active_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_scene_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_review_history: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ReviewHistoryEntryDict' },
  },
  short_video_group: {
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_storyboard_path: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_reference_images: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  sound_expert: {
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_upstream: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_duration: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_profile: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'VoiceProfileDict' },
    in_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_loop: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_lyrics_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_generated_audio: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'SoundGeneratedAudioDict' },
  },
  speech_generator: {
    in_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_profile: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'VoiceProfileDict' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_character_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_map: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'dict[str, VoiceMapEntryDict]' },
    in_pause_ms: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_provider: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    out_audio_file: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_duration_seconds: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    out_waveform: { schemaType: 'json', wireType: 'array', isMulti: false, baseType: 'list[float]' },
    out_generated_audio: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'GeneratedAudioWithHistory' },
    in_generated_audio: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'GeneratedAudioWithHistory' },
  },
  story_direction_preview: {
  },
  storyboard_designer: {
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_character_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_location_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_objects: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_object_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_reference_images: { schemaType: 'image', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_panel_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_location: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_storyboard_grid: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    out_metadata: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'MetadataDict' },
    out_beats: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    out_panel_refs: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'list[str]' },
    out_panel_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
  },
  storyboard_no_enhance_designer: {
    in_script: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_characters: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_character_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_locations: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_location_names: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_panel_count: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_location: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_storyboard_grid: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  style_selector: {
    out_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  text: {
    in_input: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_text: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
  },
  video: {
    in_file_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  video_editor: {
    in_video_paths: { schemaType: 'video', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_audio_paths: { schemaType: 'audio', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_audio_path: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_output_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_start: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_end: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_volume: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_timeline_config: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'dict' },
    out_video_output: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_rendered_clip_paths: { schemaType: 'json', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  video_generator: {
    in_mode: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_clip_number: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_reference_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_audio: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    in_motion_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_scene_context: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_duration: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    in_dialogue_prompt: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'DialogueEntryDict' },
    in_model: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_resolution: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_generate_audio: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_tts_provider: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_voice_map: { schemaType: 'json', wireType: 'array', isMulti: true, baseType: 'VoiceProfileDict' },
    in_voice_settings: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'VoiceSettingsDict' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_resolved_voice_map: { schemaType: 'json', wireType: 'map', isMulti: false, baseType: 'dict[str, str]' },
    in_audio_remix_config: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'AudioRemixConfigDict' },
    out_generated_video: { schemaType: 'video', wireType: 'json', isMulti: false, baseType: 'GeneratedVideoWithHistory' },
    out_remixed_video: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_replacement_mix: { schemaType: 'audio', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
    out_tts_segments: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'TtsSegmentDict' },
    out_speech_windows: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'SpeechWindowDict' },
    out_video_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_video_duration: { schemaType: 'float', wireType: 'primitive', isMulti: false, baseType: 'float' },
    out_dialogue: { schemaType: 'json', wireType: 'json', isMulti: false, baseType: 'ReconciledDialogueEntryDict' },
    out_video_path: { schemaType: 'video', wireType: 'primitive', isMulti: false, baseType: 'RelativePath' },
  },
  webtoon_group: {
    in_scene_id: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_label: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_collapsed: { schemaType: 'boolean', wireType: 'primitive', isMulti: false, baseType: 'bool' },
    in_child_node_ids: { schemaType: 'string', wireType: 'array', isMulti: false, baseType: 'list[str]' },
  },
  webtoon_panel_generator: {
    in_reference_images: { schemaType: 'image', wireType: 'array', isMulti: true, baseType: 'RelativePath' },
    in_prompt: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_beats: { schemaType: 'string', wireType: 'array', isMulti: true, baseType: 'str' },
    in_dialogue: { schemaType: 'json', wireType: 'array', isMulti: true, baseType: 'WebtoonDialogueDict' },
    in_panel_index: { schemaType: 'int', wireType: 'primitive', isMulti: false, baseType: 'int' },
    in_aspect_ratio: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_layout: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_style: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'VisualStyle' },
    in_name: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    in_feedback: { schemaType: 'string', wireType: 'primitive', isMulti: false, baseType: 'str' },
    out_panel_image: { schemaType: 'image', wireType: 'map', isMulti: false, baseType: 'GeneratedImageWithHistory' },
  },
}

// ---------------------------------------------------------------------------
// YDoc deserializer helpers (schema-driven, replaces heuristic parsing)
// ---------------------------------------------------------------------------

function _ydocPassthrough(v: unknown): unknown {
  if (v instanceof Y.Array) return v.toArray()
  return v
}

function _ydocParseJson(v: unknown): unknown {
  if (v instanceof Y.Array) return v.toArray()
  if (typeof v === 'string') { try { return JSON.parse(v) } catch { return v } }
  return v
}

function _ydocParseArray(v: unknown): unknown {
  if (v instanceof Y.Array) return v.toArray()
  return v
}

function _ydocParseMap(v: unknown): unknown {
  if (v instanceof Y.Map) {
    // GeneratedImageWithHistory shape: has 'history' key
    if (v.get('history') !== undefined) {
      const histArr = v.get('history')
      let history: unknown[]
      if (histArr instanceof Y.Array) {
        history = histArr.toArray().map((item: unknown) =>
          typeof item === 'string' ? JSON.parse(item) : item)
      } else if (Array.isArray(histArr)) {
        history = histArr.map((item: unknown) =>
          typeof item === 'string' ? JSON.parse(item) : item)
      } else { history = [] }
      return { history, picked_index: v.get('picked_index') ?? 0 }
    }
    // Plain dict shape: convert Y.Map to plain object
    return v.toJSON()
  }
  // TODO: Add a YDoc room migration to convert legacy JSON-string map fields
  // to native Y.Map, then remove this fallback.
  // Fallback: legacy JSON string
  if (typeof v === 'string') { try { return JSON.parse(v) } catch { return v } }
  return v
}

export const YDOC_DESERIALIZERS: Record<string, Record<string, (v: unknown) => unknown>> = {
  audio: {
    in_file_name: _ydocPassthrough,
    out_audio: _ydocPassthrough,
  },
  character_designer: {
    in_upstream: _ydocParseJson,
    in_reference_images: _ydocParseArray,
    in_name: _ydocPassthrough,
    in_role: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_description: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_name: _ydocPassthrough,
    out_character_sheet: _ydocParseJson,
    out_voice_profile: _ydocParseJson,
    out_image_path: _ydocPassthrough,
  },
  debug_hang: {
    in_label: _ydocPassthrough,
    out_result: _ydocPassthrough,
  },
  dialogue_writer: {
    in_storyboard: _ydocParseArray,
    in_story_context: _ydocPassthrough,
    in_characters: _ydocParseArray,
    out_dialogue: _ydocParseJson,
  },
  director: {
    in_context: _ydocPassthrough,
    out_response: _ydocPassthrough,
    out_crew: _ydocParseJson,
  },
  generated_image_with_history: {
  },
  image: {
    in_file_name: _ydocPassthrough,
    out_image: _ydocPassthrough,
  },
  image_generator: {
    in_reference_images: _ydocParseArray,
    in_upstream: _ydocParseJson,
    in_name: _ydocPassthrough,
    in_prompt: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_quality: _ydocPassthrough,
    in_panel_refs: _ydocParseArray,
    in_update: _ydocPassthrough,
    in_image: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    in_video: _ydocPassthrough,
    in_frame: _ydocPassthrough,
    in_get_frame: _ydocPassthrough,
    out_generated_image: _ydocParseMap,
    out_image_path: _ydocPassthrough,
  },
  location_designer: {
    in_reference_images: _ydocParseArray,
    in_name: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_time_of_day: _ydocPassthrough,
    in_weather: _ydocPassthrough,
    in_description: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_name: _ydocPassthrough,
    out_location_image: _ydocParseJson,
    out_metadata: _ydocParseJson,
    out_image_path: _ydocPassthrough,
  },
  music_generator: {
    in_prompt: _ydocPassthrough,
    in_length: _ydocPassthrough,
    out_audio_file: _ydocPassthrough,
  },
  node_group: {
    in_label: _ydocPassthrough,
    in_child_node_ids: _ydocParseArray,
    in_layout_mode: _ydocPassthrough,
  },
  object_designer: {
    in_reference_images: _ydocParseArray,
    in_name: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_description: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_name: _ydocPassthrough,
    out_object_image: _ydocParseJson,
    out_metadata: _ydocParseJson,
    out_image_path: _ydocPassthrough,
  },
  panel_source: {
    out_image: _ydocPassthrough,
    out_action: _ydocPassthrough,
    out_characterIds: _ydocParseArray,
    out_appearances: _ydocParseJson,
    out_dialogue: _ydocParseJson,
    out_script: _ydocPassthrough,
    out_composition: _ydocParseJson,
  },
  prompt_input: {
    out_prompt: _ydocPassthrough,
  },
  screenplay_writer: {
    in_story_context: _ydocParseJson,
    in_characters: _ydocParseArray,
    in_locations: _ydocParseArray,
    in_user_script: _ydocPassthrough,
    in_style: _ydocPassthrough,
    out_panels: _ydocParseJson,
    out_transitions: _ydocParseJson,
    out_dialogue: _ydocParseJson,
    out_music_prompts: _ydocParseArray,
  },
  script_writer: {
    in_prompt: _ydocPassthrough,
    in_active_model: _ydocPassthrough,
    in_name: _ydocPassthrough,
    in_director_instruction: _ydocPassthrough,
    in_format_only: _ydocPassthrough,
    in_characters: _ydocParseArray,
    in_feedback: _ydocPassthrough,
    in_target_duration_s: _ydocPassthrough,
    out_script: _ydocPassthrough,
    out_script_path: _ydocPassthrough,
    out_screenplay: _ydocParseJson,
    out_dialogue: _ydocParseJson,
    out_action_lines: _ydocParseJson,
    out_characters: _ydocParseArray,
    out_music_cues: _ydocParseJson,
    out_sfx: _ydocParseJson,
    out_gemini: _ydocParseJson,
    out_claude: _ydocParseJson,
    out_gpt: _ydocParseJson,
    out_locations: _ydocParseArray,
    out_active_model: _ydocPassthrough,
    out_scene_count: _ydocPassthrough,
    in_review_history: _ydocParseJson,
  },
  short_video_group: {
    in_label: _ydocPassthrough,
    in_collapsed: _ydocPassthrough,
    in_storyboard_path: _ydocPassthrough,
    in_reference_images: _ydocPassthrough,
    in_child_node_ids: _ydocParseArray,
  },
  sound_expert: {
    in_name: _ydocPassthrough,
    in_upstream: _ydocParseJson,
    in_prompt: _ydocPassthrough,
    in_mode: _ydocPassthrough,
    in_duration: _ydocPassthrough,
    in_voice_profile: _ydocParseJson,
    in_text: _ydocPassthrough,
    in_model: _ydocPassthrough,
    in_loop: _ydocPassthrough,
    in_lyrics_mode: _ydocPassthrough,
    out_audio: _ydocPassthrough,
    out_duration_seconds: _ydocPassthrough,
    in_generated_audio: _ydocParseJson,
  },
  speech_generator: {
    in_text: _ydocPassthrough,
    in_voice_profile: _ydocParseJson,
    in_scene_id: _ydocPassthrough,
    in_mode: _ydocPassthrough,
    in_script: _ydocPassthrough,
    in_voice_id: _ydocPassthrough,
    in_character_name: _ydocPassthrough,
    in_voice_map: _ydocParseJson,
    in_pause_ms: _ydocPassthrough,
    in_provider: _ydocPassthrough,
    in_panel_index: _ydocPassthrough,
    out_audio_file: _ydocPassthrough,
    out_duration_seconds: _ydocPassthrough,
    out_waveform: _ydocParseArray,
    out_generated_audio: _ydocParseJson,
    in_generated_audio: _ydocParseJson,
  },
  story_direction_preview: {
  },
  storyboard_designer: {
    in_script: _ydocPassthrough,
    in_characters: _ydocParseArray,
    in_character_names: _ydocParseArray,
    in_locations: _ydocParseArray,
    in_location_names: _ydocParseArray,
    in_objects: _ydocParseArray,
    in_object_names: _ydocParseArray,
    in_reference_images: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_panel_count: _ydocPassthrough,
    in_scene_id: _ydocPassthrough,
    in_location: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_storyboard_grid: _ydocParseArray,
    out_metadata: _ydocParseJson,
    out_beats: _ydocParseArray,
    out_panel_refs: _ydocParseArray,
    out_panel_images: _ydocParseArray,
  },
  storyboard_no_enhance_designer: {
    in_script: _ydocPassthrough,
    in_characters: _ydocParseArray,
    in_character_names: _ydocParseArray,
    in_locations: _ydocParseArray,
    in_location_names: _ydocParseArray,
    in_style: _ydocPassthrough,
    in_panel_count: _ydocPassthrough,
    in_scene_id: _ydocPassthrough,
    in_location: _ydocPassthrough,
    out_storyboard_grid: _ydocPassthrough,
  },
  style_selector: {
    out_style: _ydocPassthrough,
  },
  text: {
    in_input: _ydocPassthrough,
    out_text: _ydocPassthrough,
  },
  video: {
    in_file_name: _ydocPassthrough,
    out_video: _ydocPassthrough,
  },
  video_editor: {
    in_video_paths: _ydocParseArray,
    in_audio_paths: _ydocParseArray,
    in_audio_path: _ydocPassthrough,
    in_mode: _ydocPassthrough,
    in_output_name: _ydocPassthrough,
    in_start: _ydocPassthrough,
    in_end: _ydocPassthrough,
    in_volume: _ydocPassthrough,
    in_timeline_config: _ydocParseJson,
    out_video_output: _ydocPassthrough,
    out_rendered_clip_paths: _ydocParseArray,
  },
  video_generator: {
    in_mode: _ydocPassthrough,
    in_scene_id: _ydocPassthrough,
    in_clip_number: _ydocPassthrough,
    in_reference_images: _ydocParseArray,
    in_audio: _ydocPassthrough,
    in_motion_prompt: _ydocPassthrough,
    in_scene_context: _ydocPassthrough,
    in_duration: _ydocPassthrough,
    in_dialogue_prompt: _ydocParseJson,
    in_model: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_resolution: _ydocPassthrough,
    in_generate_audio: _ydocPassthrough,
    in_tts_provider: _ydocPassthrough,
    in_voice_map: _ydocParseArray,
    in_voice_settings: _ydocParseJson,
    in_name: _ydocPassthrough,
    in_resolved_voice_map: _ydocParseMap,
    in_audio_remix_config: _ydocParseJson,
    out_generated_video: _ydocParseJson,
    out_remixed_video: _ydocPassthrough,
    out_replacement_mix: _ydocPassthrough,
    out_tts_segments: _ydocParseJson,
    out_speech_windows: _ydocParseJson,
    out_video_prompt: _ydocPassthrough,
    out_video_duration: _ydocPassthrough,
    out_dialogue: _ydocParseJson,
    out_video_path: _ydocPassthrough,
  },
  webtoon_group: {
    in_scene_id: _ydocPassthrough,
    in_label: _ydocPassthrough,
    in_collapsed: _ydocPassthrough,
    in_child_node_ids: _ydocParseArray,
  },
  webtoon_panel_generator: {
    in_reference_images: _ydocParseArray,
    in_prompt: _ydocPassthrough,
    in_beats: _ydocParseArray,
    in_dialogue: _ydocParseArray,
    in_panel_index: _ydocPassthrough,
    in_aspect_ratio: _ydocPassthrough,
    in_layout: _ydocPassthrough,
    in_style: _ydocPassthrough,
    in_name: _ydocPassthrough,
    in_feedback: _ydocPassthrough,
    out_panel_image: _ydocParseMap,
  },
}

/** Frontend type to backend type mapping (from schema type → backendType) */
export const FE_TYPE_TO_BACKEND: Record<string, string> = {
  audio: 'audio',
  characterDesigner: 'character_designer',
  debugHang: 'debug_hang',
  dialogueWriter: 'dialogue_writer',
  director: 'director',
  generatedImageWithHistory: 'generated_image_with_history',
  image: 'image',
  imageGenerator: 'image_generator',
  locationDesigner: 'location_designer',
  musicGenerator: 'music_generator',
  nodeGroup: 'node_group',
  objectDesigner: 'object_designer',
  panelSource: 'panel_source',
  promptInput: 'prompt_input',
  screenplayWriter: 'screenplay_writer',
  scriptWriter: 'script_writer',
  shortVideoGroup: 'short_video_group',
  soundExpert: 'sound_expert',
  speechGenerator: 'speech_generator',
  storyDirectionPreview: 'story_direction_preview',
  storyboardDesigner: 'storyboard_designer',
  storyboardNoEnhanceDesigner: 'storyboard_no_enhance_designer',
  styleSelector: 'style_selector',
  text: 'text',
  video: 'video',
  videoEditor: 'video_editor',
  videoGenerator: 'video_generator',
  webtoonGroup: 'webtoon_group',
  webtoonPanelGenerator: 'webtoon_panel_generator',
}

/** Node types hidden on the ReactFlow canvas (from canvasHidden in schemas) */
export const CANVAS_HIDDEN_FE_TYPES: ReadonlySet<string> = new Set(['director', 'storyDirectionPreview', 'storyboardDesigner', 'storyboardNoEnhanceDesigner'])
